module.exports = __webpack_public_path__ + "static/heroBg4-ff45f3b1971cfd435677df652c8db55d.jpg";